module.exports = __webpack_public_path__ + "img/Bosque.9651a764.png";